import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import React, { useMemo } from 'react'

interface Props {
  offer: App.CruiseOffer;
}

export function HeroCruiseLocation({ offer }: Props) {
  const { departurePort, returnPort } = offer
  const hasTheSameStartAndEndPort = departurePort === returnPort
  const returnPortCity = useMemo(() => returnPort?.split(',')?.[0], [returnPort])
  const departurePortCity = useMemo(() => departurePort?.split(',')?.[0], [departurePort])

  return (
    <Group direction="horizontal" gap={4}>
      <Caption variant="large" lineClamp={3} colour="neutral-one">
        {hasTheSameStartAndEndPort && (
          <span>
            Starts and ends in <b>{returnPortCity}</b>
          </span>
        )}
        {!hasTheSameStartAndEndPort && (
          <span>
            Starts in <b>{departurePortCity}</b>. Ends in <b>{returnPortCity}</b>
          </span>
        )}
      </Caption>
      <Caption variant="large" colour="neutral-three">
        ·
      </Caption>
      <Caption variant="large" colour="neutral-three">
        Cruise
      </Caption>
    </Group>
  )
}
